import React, { useState, useMemo } from "react";
import { LOGO_LIBRARY } from "@/lib/logoLibrary";
import { Input } from "@/components/ui/input";

export default function LogoPicker({ value, onChange }) {
  const [query, setQuery] = useState("");
  const [group, setGroup] = useState("all");

  const groups = useMemo(() => {
    const set = new Set(LOGO_LIBRARY.map((l) => l.group));
    return ["all", ...set];
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return LOGO_LIBRARY.filter((l) => {
      if (group !== "all" && l.group !== group) return false;
      if (!q) return true;
      return (
        l.label.toLowerCase().includes(q) ||
        l.key.toLowerCase().includes(q) ||
        l.group.toLowerCase().includes(q)
      );
    });
  }, [query, group]);

  return (
    <div className="space-y-3" data-testid="logo-picker">
      <Input
        placeholder={`Rechercher parmi ${LOGO_LIBRARY.length} icônes (slack, github, cloud, money…)`}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        data-testid="logo-picker-search"
      />
      <div className="flex gap-1.5 flex-wrap" data-testid="logo-picker-groups">
        {groups.map((g) => (
          <button
            key={g}
            type="button"
            onClick={() => setGroup(g)}
            className={`px-2.5 py-1 rounded-sm text-[11px] uppercase tracking-wider font-medium border transition-colors ${
              group === g
                ? "bg-primary text-primary-foreground border-primary"
                : "border-border bg-background hover:bg-accent"
            }`}
            data-testid={`logo-picker-group-${g}`}
          >
            {g === "all" ? "Toutes" : g}
          </button>
        ))}
      </div>
      <div className="max-h-56 sm:max-h-72 overflow-y-auto border border-border rounded-sm p-3">
        <div className="grid grid-cols-6 sm:grid-cols-8 md:grid-cols-10 gap-2">
          {filtered.map((item) => {
            const selected = value === item.key;
            return (
              <button
                key={item.key}
                type="button"
                onClick={() => onChange(item.key)}
                className={`group relative aspect-square rounded-sm border flex items-center justify-center transition-all duration-150 ${
                  selected
                    ? "border-primary ring-2 ring-primary bg-accent text-primary"
                    : "border-border hover:border-primary/50 hover:bg-accent text-foreground"
                }`}
                title={item.label}
                data-testid={`logo-option-${item.key}`}
              >
                <i className={item.faClass} style={{ fontSize: 18 }} aria-hidden="true" />
              </button>
            );
          })}
        </div>
        {filtered.length === 0 && (
          <p className="text-sm text-muted-foreground text-center py-6">
            Aucune icône ne correspond à votre recherche.
          </p>
        )}
        <p className="text-[11px] text-muted-foreground mt-3 text-center">
          {filtered.length} / {LOGO_LIBRARY.length} icônes
        </p>
      </div>
    </div>
  );
}
